import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { IoMdRefresh } from "react-icons/io";
import { Chart, ArcElement, LineElement, PointElement, LinearScale, Tooltip, Legend, CategoryScale } from "chart.js";
import { Pie, Line } from 'react-chartjs-2';
import Select from "react-select";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import CabecalhoAdmin from "../../../../componentes/CabecalhoAdmin";
import MenuLateral from "../../../../componentes/MenuLateral";
import ErroSpan from "../../../../componentes/ErroSpan";
import { AreaSuperior, FiltrarData, InputMes, OpcoesFiltragem, SecaoAdmin, SecaoPrincipal } from "../../AdminStyled";
import { totaisPorTipo } from "../../../../servicos/ticketsServices";
import { AreaRelatorio, LadoALado } from "../IndicadoresStyled";

// Register the necessary Chart.js components
Chart.register(ArcElement, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend, ChartDataLabels);

export default function PorTipo() {
    const [params, setParams] = useSearchParams();
    const [filtros, setFiltros] = useState({
        dataInicial: params.get("dataInicial"),
        dataFinal: params.get("dataFinal"),
        tipo: params.get("tipo")
    });
    const [carregando, setCarregando] = useState(true);
    const [dadosTipo, setDadosTipo] = useState(null);
    const [dadosFds, setDadosFds] = useState(null);
    const [dadosDiasUteis, setDadosDiasUteis] = useState(null);
    const [dadosPorDia, setDadosPorDia] = useState(null);

    // Variável de controle e configuração dos tipos dos ingressos nos relatórios
    const tiposConfig = [
        {
            label: "INDIVIDUAL",
            value: "individual",
            key: "individuais",
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)'
        },
        {
            label: "INDIVIDUAL-ONLINE",
            value: "individualOnline",
            key: "individuaisOnline",
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)'
        },
        {
            label: "PROMOCIONAL-EXCURSÃO",
            value: "promocionalExcursao",
            key: "promocionaisExcursao",
            backgroundColor: 'rgba(255, 206, 86, 0.2)',
            borderColor: 'rgba(255, 206, 86, 1)'
        },
        {
            label: "PROMOCIONAL-ESCOLAR",
            value: "promocionalEscolar",
            key: "promocionaisEscolar",
            backgroundColor: 'rgba(60, 60, 255, 0.2)',
            borderColor: 'rgba(60, 60, 255, 1)'
        },
        {
            label: "INFANTIL",
            value: "infantil",
            key: "infantis",
            backgroundColor: 'rgba(255, 98, 7, 0.2)',
            borderColor: 'rgb(255, 98, 7)'
        },
        {
            label: "INFANTIL-ONLINE",
            value: "infantilOnline",
            key: "infantisOnline",
            backgroundColor: 'rgba(153, 102, 255, 0.2)',
            borderColor: 'rgba(153, 102, 255, 1)'
        },
        {
            label: "CORTESIA",
            value: "cortesia",
            key: "cortesias",
            backgroundColor: 'rgba(134, 255, 64, 0.2)',
            borderColor: 'rgb(134, 255, 64)'
        },
        {
            label: "PROMOCIONAL",
            value: "promocional",
            key: "promocionais",
            backgroundColor: 'rgba(255, 159, 64, 0.2)',
            borderColor: 'rgba(255, 159, 64, 1)'
        },
        {
            label: "PROMOCIONAL-ONLINE",
            value: "promocionalOnline",
            key: "promocionaisOnline",
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderColor: 'rgba(75, 192, 192, 1)'
        }
    ];

    useEffect(() => {
        if (params.get("dataInicial") && params.get("dataFinal")) {
            setCarregando(true);
            totaisPorTipo(params.get("dataInicial"), params.get("dataFinal"), params.get("tipo")).then( resposta => {
                setDadosTipo({
                    labels: tiposConfig.map(t => t.label),
                    datasets: [
                        {
                            label: "Totais por Tipo",
                            data: tiposConfig.map(
                                t => resposta[t.key].reduce(
                                    (acumulador, atual) => acumulador + atual,
                                    0
                                )
                            ),
                            backgroundColor: tiposConfig.map(t => t.backgroundColor),
                            borderColor: tiposConfig.map(t => t.borderColor),
                            borderWidth: 1,
                        }
                    ]
                });
                setDadosFds({
                    labels: tiposConfig.map(t => t.label),
                    datasets: [
                        {
                            label: "Tipos nos finais de semana",
                            data: tiposConfig.map(
                                t => resposta[t.key][0] + resposta[t.key][6]
                            ),
                            backgroundColor: tiposConfig.map(t => t.backgroundColor),
                            borderColor: tiposConfig.map(t => t.borderColor),
                            borderWidth: 1,
                        }
                    ]
                });
                setDadosDiasUteis({
                    labels: tiposConfig.map(t => t.label),
                    datasets: [
                        {
                            label: "Totais por Tipo",
                            data: tiposConfig.map(t =>
                                resposta[t.key][1] +
                                resposta[t.key][2] +
                                resposta[t.key][3] +
                                resposta[t.key][4] +
                                resposta[t.key][5]
                            ),
                            backgroundColor: tiposConfig.map(t => t.backgroundColor),
                            borderColor: tiposConfig.map(t => t.borderColor),
                            borderWidth: 1,
                        }
                    ]
                });
                setDadosPorDia({
                    labels: [
                        "Domingo",
                        "Segunda-feira",
                        "Terça-feira",
                        "Quarta-feira",
                        "Quinta-feira",
                        "Sexta-feira",
                        "Sábado"
                    ],
                    datasets: tiposConfig.map(t => ({
                        label: t.label,
                        data: resposta[t.key],
                        borderColor: t.borderColor,
                        backgroundColor: t.backgroundColor,
                        borderWidth: 2,
                        tension: 0.4,
                    }))
                });
                setCarregando(false);
            });
        }
    }, [params]);

    function atualizarParametros() {
        setParams(params => {
            params.set("dataInicial", filtros.dataInicial);
            params.set("dataFinal", filtros.dataFinal);
            params.set("tipo", filtros.tipo);
            return params;
        });
    }
    
    return (
        <SecaoAdmin>
            <MenuLateral />
            <SecaoPrincipal>
                {CabecalhoAdmin("Indicadores por tipo de ingresso")}
                <AreaSuperior>
                    <OpcoesFiltragem>
                        <FiltrarData $marginTop="1px">
                            <label>Data inicial</label>
                            <InputMes type="date" defaultValue={params.get("dataInicial")} onChange={event => setFiltros({...filtros, dataInicial: event.target.value})}/>
                        </FiltrarData>
                        <FiltrarData $marginTop="1px">
                            <label>Data final</label>
                            <InputMes type="date" defaultValue={params.get("dataFinal")} onChange={event => setFiltros({...filtros, dataFinal: event.target.value})}/>
                        </FiltrarData>
                        <FiltrarData>
                            <label>Tipos</label>
                            <Select 
                                options={tiposConfig} 
                                isMulti
                                isClearable="false"
                                placeholder="Tipo"
                                value={
                                    filtros.tipo ? 
                                    tiposConfig.filter( t => filtros.tipo.split(',').includes(t.label)) 
                                    : []}
                                onChange={e => {
                                    const tipos = e?.map(item => item.label).join(',') || '';

                                    setFiltros({...filtros, tipo: tipos});
                                }}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderRadius: "2px",
                                        border: "1px solid #252525",
                                        width: "500px",
                                        height: "31px",
                                        minHeight: '30px',
                                        fontSize: "14px",
                                        borderColor: state.hover ? 'black' : 'rgba(58, 23, 14, 0.308)' 
                                    }),
                                    input: (provided, state) => ({
                                        ...provided,
                                        margin: '0px',
                                        }),
                                    valueContainer: (provided, state) => ({
                                        ...provided,
                                        height: '30px',
                                        padding: '0 6px'
                                    }),
                                    indicatorsContainer: (provided, state) => ({
                                        ...provided,
                                        height: '30px',
                                    }),
                                    option: (baseStyles) => ({
                                        ...baseStyles,
                                        color: "black"
                                    })
                                }}
                            />
                        </FiltrarData>
                        <IoMdRefresh className="Icone" onClick={() => atualizarParametros()}/>
                    </OpcoesFiltragem>
                </AreaSuperior>
                {carregando && <ErroSpan>Carregando...</ErroSpan>}
                <LadoALado $margem="10px 5px 0px 5px">
                    {dadosTipo && <AreaRelatorio $maxLargura="33%">
                        <Pie data={dadosTipo} options={{
                            plugins: {
                                legend: {
                                    position: 'bottom',  // Position the legend below the chart
                                },
                                title: {
                                    text: "Total",
                                    display: true,
                                    font: {
                                        size: "16px"
                                    },
                                    color: '#252525'
                                }, 
                                datalabels: {
                                    formatter: (value, ctx) => {
                                        const datapoints = ctx.chart.data.datasets[0].data;
                                        const total = datapoints.reduce((total, datapoint) => total + datapoint, 0);
                                        const percentage = value / total * 100;
                                        return percentage.toFixed(2) + "%";
                                    },
                                    color: '#25252594'
                                }
                            }
                        }}/>
                    </AreaRelatorio>}
                    {dadosFds && <AreaRelatorio $maxLargura="33%">
                        <Pie data={dadosFds} options={{
                            plugins: {
                                legend: {
                                    position: 'bottom',
                                },
                                title: {
                                    text: "Finais de semana",
                                    display: true,
                                    font: {
                                        size: "16px"
                                    },
                                    color: '#252525'
                                }, 
                                datalabels: {
                                    formatter: (value, ctx) => {
                                        const datapoints = ctx.chart.data.datasets[0].data;
                                        const total = datapoints.reduce((total, datapoint) => total + datapoint, 0);
                                        const percentage = value / total * 100;
                                        return percentage.toFixed(2) + "%";
                                    },
                                    color: '#25252594'
                                }
                            }
                        }}/>
                    </AreaRelatorio>}
                    {dadosDiasUteis && <AreaRelatorio $maxLargura="33%">
                        <Pie data={dadosDiasUteis} options={{
                            plugins: {
                                legend: {
                                    position: 'bottom',
                                },
                                title: {
                                    text: "Dias da semana",
                                    display: true,
                                    font: {
                                        size: "16px"
                                    },
                                    color: '#252525'
                                }, 
                                datalabels: {
                                    formatter: (value, ctx) => {
                                        const datapoints = ctx.chart.data.datasets[0].data;
                                        const total = datapoints.reduce((total, datapoint) => total + datapoint, 0);
                                        const percentage = value / total * 100;
                                        return percentage.toFixed(2) + "%";
                                    },
                                    color: '#25252594'
                                }
                            }
                        }}/>
                    </AreaRelatorio>}
                </LadoALado>
                {dadosPorDia && <AreaRelatorio $maxLargura="1000px">
                    <Line data={dadosPorDia} options={{
                        plugins: {
                            legend: {
                                position: 'bottom',
                            },
                            title: {
                                text: "Análise por dia da semana",
                                display: true,
                                font: {
                                    size: "16px"
                                },
                                color: '#252525'
                            },
                            datalabels: {
                                display: false
                            }
                        }
                    }}/>
                </AreaRelatorio>}
            </SecaoPrincipal>
        </SecaoAdmin>
    )
}